import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '资讯', to: '/news' },
  { label: '关于', to: '/about' },
];

const HOT_KEYWORDS = ['星际迷航', '长安风云录', '科幻', '悬疑', '春节档'];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="hidden bg-primary-800 text-primary-50 md:block">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between px-4 text-xs md:px-6">
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-accent-300" />
            91爱爱 · 最新影视资源与影视资讯平台
          </span>
          <div className="flex items-center gap-4">
            <span className="text-primary-200">热门搜索：</span>
            <div className="flex items-center gap-3">
              {HOT_KEYWORDS.map((word) => (
                <Link
                  key={word}
                  to={`/search?q=${encodeURIComponent(word)}`}
                  className="whitespace-nowrap transition-colors hover:text-accent-300"
                >
                  {word}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="91爱爱首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-movie-2-line text-lg" />
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            91<span className="text-accent-500">爱爱</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center md:ml-2">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs lg:block">
          <SearchBar size="sm" />
        </div>

        <div className="ml-auto flex items-center gap-2 lg:ml-3">
          <button
            type="button"
            aria-label="展开搜索"
            onClick={() => setSearchOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 lg:hidden cursor-pointer"
          >
            <i className="ri-search-line text-lg" />
          </button>
          <Link
            to="/about"
            className="hidden h-9 items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-3 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100 sm:flex cursor-pointer"
          >
            <i className="ri-information-line" />
            平台介绍
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <SearchBar size="sm" onSubmitted={() => setSearchOpen(false)} />
        </div>
      )}

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-2">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                <i className="ri-arrow-right-s-line text-foreground-400" />
                {item.label}
              </NavLink>
            ))}
            <div className="px-3 pb-3 pt-2">
              <SearchBar size="md" onSubmitted={() => setMenuOpen(false)} />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}